import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";

const AppHome = () => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(true);

  console.log("AppHome: Component rendering", {
    loading,
    userRole,
    timestamp: new Date().toISOString(),
  });

  // 第一个useEffect用于认证检查
  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      console.log("AppHome: Starting auth check");
      const role = localStorage.getItem("userRole");
      const token = localStorage.getItem("token");
      console.log(
        "AppHome: Auth check with role:",
        role,
        "token exists:",
        !!token,
      );

      if (!role || !token) {
        console.log("AppHome: Missing role or token, redirecting to login");
        localStorage.clear();
        navigate("/");
        return;
      }

      if (!mounted) {
        console.log("AppHome: Component unmounted during auth check");
        return;
      }

      try {
        console.log("AppHome: Setting user role", {
          currentRole: userRole,
          newRole: role,
          timestamp: new Date().toISOString(),
        });
        setUserRole(role);

        console.log("AppHome: Setting loading state to false", {
          currentLoading: loading,
          timestamp: new Date().toISOString(),
        });
        setLoading(false);
      } catch (error) {
        console.error("AppHome: Error during initialization:", error);
        if (mounted) {
          localStorage.clear();
          navigate("/");
        }
      }
    };

    checkAuth();
    return () => {
      mounted = false;
      console.log("AppHome: Component cleanup");
    };
  }, [navigate]);

  // 第二个useEffect用于清理loading遮罩
  useEffect(() => {
    const loadingOverlay = document.querySelector(
      ".fixed.inset-0.bg-black.bg-opacity-50",
    );
    console.log("AppHome: Loading overlay found:", !!loadingOverlay);

    if (loadingOverlay) {
      console.log("AppHome: Attempting to remove loading overlay");
      try {
        loadingOverlay.remove();
        console.log("AppHome: Loading overlay removed successfully");
      } catch (error) {
        console.error("AppHome: Error removing loading overlay:", error);
      }
    }

    return () => {
      console.log("AppHome: Loading overlay effect cleanup");
    };
  }, [loading, userRole]); // 添加所有必要的依赖

  const rolePermissions = {
    admin: ["construction", "planfile", "marketing"],
    office: ["construction", "planfile", "marketing"],
    pm: ["construction", "planfile"],
    consultant: ["planfile"],
    site: ["construction"],
    marketing: ["marketing"],
  };

  const hasAccess = (scenario) => {
    return rolePermissions[userRole]?.includes(scenario);
  };

  const handleSelectScenario = (scenario) => {
    if (!hasAccess(scenario)) {
      alert("You do not have permission to access this section.");
      return;
    }
    navigate(`/select_project?type=${scenario}`);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-green-500"></div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 flex flex-col bg-white shadow-lg ml-[60px]">
        <div className="flex justify-end p-3 sm:p-4 md:p-5">
          <img
            src="/images/gemterra-logo-20260112-t.png"
            alt="Gemterra"
            className="w-32 sm:w-40 md:w-48"
          />
        </div>

        <div className="flex-1 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 lg:gap-8 p-4 md:p-6 lg:p-8">
          {hasAccess("construction") && (
            <div
              className="relative w-full md:w-1/3 aspect-square cursor-pointer transition transform hover:-translate-y-1 hover:shadow-xl"
              onClick={() => handleSelectScenario("construction")}
            >
              <img
                src={process.env.PUBLIC_URL + "/images/construction.webp"}
                alt="Construction"
                className="w-full h-full object-cover rounded-lg shadow-md"
              />
              {/* <div
                className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold drop-shadow-lg text-center w-full"
                style={{ WebkitTextStroke: "1px #666666" }}
              >
                Construction
              </div> */}
            </div>
          )}

          {hasAccess("planfile") && (
            <div
              className="relative w-full md:w-1/3 aspect-square cursor-pointer transition transform hover:-translate-y-1 hover:shadow-xl"
              onClick={() => handleSelectScenario("planfile")}
            >
              <img
                src={process.env.PUBLIC_URL + "/images/plan_file.webp"}
                alt="Plan File"
                className="w-full h-full object-cover rounded-lg shadow-md"
              />
              {/* <div className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 text-black text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold drop-shadow-lg text-center w-full">
                Plan File
              </div> */}
            </div>
          )}

          {hasAccess("marketing") && (
            <div
              className="relative w-full md:w-1/3 aspect-square cursor-pointer transition transform hover:-translate-y-1 hover:shadow-xl"
              onClick={() => handleSelectScenario("marketing")}
            >
              <img
                src={process.env.PUBLIC_URL + "/images/marketing.webp"}
                alt="Marketing"
                className="w-full h-full object-cover rounded-lg shadow-md"
              />
              {/* <div
                className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold drop-shadow-lg text-center w-full"
                style={{ WebkitTextStroke: "1px #666666" }}
              >
                Marketing
              </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppHome;
